import React, { Component } from "react";
import { Container, Row} from "react-bootstrap";
import { Col } from "react-bootstrap";
import About from "./AboutComp";

// Import constant url
import { NOT_FOUND_URL } from "../utils/Const";



export default function NantenimientoComp() {
    return (
        <div className="agents-header-container ">
      <img src={NOT_FOUND_URL + "404valo.webp"}   id="myVideo"/>
      <div className="header-overlay"></div>
      <Container className="agents-header-section text-white">
        <div className="img-container w-100 d-flex justify-content-center" id="agentArt">
          <img src={NOT_FOUND_URL + "relojarena.png"} alt="header-char"  width="300" height="300"/>
        </div>
      </Container>
      <Container>
      <Row className="agent-header-text">
          <Col lg={8}>
            {/* <div className="agent-number" id="agentNumber">
              <h1><strong>{agents[agentIndex].id}</strong></h1>
            </div> */}
          </Col>
          <Col>
            <section className="agent-description-section d-flex flex-column justify-content-center ms-lg-5 ms-sm-2">
        {/* <p>|| Nombre</p> */}
        <h2 className="agent-name">
          <strong>Sitio en mantenimiento</strong>
        </h2>
        {/* <p>|| Descripcion</p> */}
        <p>
          {/* {competitiveMaps.narrativeDescription} */}
        </p>
        {/* <p>|| Sites</p> */}
        <div className="d-flex align-items-center agent-role-wrapper">
          {/* <img src={ROLE_IMG_URL + agentRole + ".webp"} alt="agent-role-icon" /> */}
          {/* <h1 className="ms-3 agent-role-text"> */}
            {/* <strong>{competitiveMaps.tacticalDescription}</strong> */}
          {/* </h1> */}
        </div>
      </section>
          </Col>
        </Row>
        <About />
      </Container>

    </div>
    )
}